const FX = {
	// shadowDefault: 'rgba(0, 0, 0, 0.1) 0px 0px 0px 0px, rgba(0, 0, 0, 0.07) 0px 0px 0px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 0px',
	// shadowHover: 'rgba(0, 0, 0, 0.1) 0px 3px 2px -1px, rgba(0, 0, 0, 0.07) 0px 3px 2px 0px, rgba(0, 0, 0, 0.06) 0px 3px 4px 0px',
	shadowDefault: '0 0px 0px 0px rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0,0,0, 0.14), 0 0px 0px 0px rgba(0,0,0, 0.12)',
	shadowHover: '0 5px 5px -3px rgba(0,0,0, 0.2), 0 3px 10px 1px rgba(0,0,0, 0.14), 0 1px 14px 2px rgba(0,0,0, 0.12)',
	transSpeedFast: '.25s',
	radiusSmall: '6px',
	radiusMedium: '12px',

	shadow: {
		default: '0 0px 0px 0px rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0,0,0, 0.14), 0 0px 0px 0px rgba(0,0,0, 0.12)',
		hover: '0 5px 5px -3px rgba(0,0,0, 0.2), 0 3px 10px 1px rgba(0,0,0, 0.14), 0 1px 14px 2px rgba(0,0,0, 0.12)',
	},

	scale: {
		active: '0.93',
		hover: '1.01',
	},

	radius: {
		small: '6px',
		medium: '12px',
	},

	speed: {
		fast: '0.25s',
		medium: '0.5',
		logn: '0.75',
	}

}

export { FX }
